import propTypes from 'prop-types'
import ArrowRightIcon from '../assets/icons/ArrowRightIcon'
import { Link } from 'react-router-dom'

const ArticleCard = ({
  image,
  title,
  category,
  description,
  link
}) => {
  return (
    <div className='Community__Events-Item'>
      <div className='d-flex flex-column' style={{ gap: '12px' }}>
        <img
          src={image}
          alt={title}
          title={title}
        />
        <span className='text-3 fw-medium text-orange'>{ category }</span>
        <div className='d-flex flex-column gap-2'>
          <span className='title-2 text-green'>
            { title }
          </span>
          <span className='text-3 text-gray-dark'>
            { description }
          </span>
        </div>
      </div>

      <div className='d-flex justify-content-end'>
        <Link className='button-new-orange d-flex align-items-center gap-2' to={link}>
          Ver más
          <ArrowRightIcon />
        </Link>
      </div>
    </div>
  )
}

ArticleCard.propTypes = {
  image: propTypes.string.isRequired,
  title: propTypes.string.isRequired,
  category: propTypes.string.isRequired,
  description: propTypes.string.isRequired,
  link: propTypes.string.isRequired,
}

export default ArticleCard